import { render, staticRenderFns } from "./heading_with_columns.vue?vue&type=template&id=dfc8d698&scoped=true&"
import script from "./heading_with_columns.vue?vue&type=script&lang=js&"
export * from "./heading_with_columns.vue?vue&type=script&lang=js&"
import style0 from "./heading_with_columns.vue?vue&type=style&index=0&id=dfc8d698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc8d698",
  null
  
)

export default component.exports